export const FallbackOutputGuidelines = `### Fallback Output Guidelines
- The Card has a built-in fallback output
- It is selected **only when no output evaluates to 'true'**
- It **cannot be added, deleted, or configured**
- Example use case: "Match 'Premium' for value 'premium', 'Standard' for value 'standard'" (NO need to mention "Other")`;
